export const CHANGE_ACTIVE_BREAKPOINT = "CHANGE_ACTIVE_BREAKPOINT";

export function changeActiveBreakPoint(breakpoint) {
    return {
        type: CHANGE_ACTIVE_BREAKPOINT,
        payload: breakpoint,
    };
}
